module.exports = __webpack_public_path__ + "components/intersport-discount-page/promo-article/static/article-image-bf5d9eae1338dc396fb8c13ffd52ac98.webp";